import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../../firebase";

const sanitizeError = (error) => ({
  code: error?.code || "unknown",
  message: error?.message || "Experience Engine run failed.",
});

export const createExperienceRun = async ({ user, demoConfig } = {}) => {
  const runRef = await addDoc(collection(db, "experience_engine_runs"), {
    status: "running",
    createdBy: user?.uid || "",
    createdByEmail: user?.email || "",
    config: demoConfig,
    eventId: null,
    currentStep: null,
    completedSteps: 0,
    totalSteps: 0,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return runRef.id;
};

export const updateExperienceRun = async (runId, updates = {}) => {
  if (!runId) return;

  await updateDoc(doc(db, "experience_engine_runs", runId), {
    ...updates,
    updatedAt: serverTimestamp(),
  });
};

export const completeExperienceRun = async ({ runId, eventId, report } = {}) =>
  updateExperienceRun(runId, {
    status: "complete",
    eventId: eventId || null,
    report: report
      ? {
          config: report.config || {},
          created: report.created || {},
          addOns: report.addOns || {},
          links: report.links || {},
          messages: report.messages || [],
        }
      : null,
    completedAt: serverTimestamp(),
  });

export const failExperienceRun = async ({ runId, eventId, error } = {}) =>
  updateExperienceRun(runId, {
    status: eventId ? "cleanup_required" : "failed",
    eventId: eventId || null,
    error: sanitizeError(error),
    failedAt: serverTimestamp(),
  });

export const cleanupFailedExperience = async ({ runId, eventId } = {}) => {
  if (!eventId) return false;

  const deleteEventCascade = httpsCallable(functions, "deleteEventCascade");
  await deleteEventCascade({ eventId });

  await updateExperienceRun(runId, {
    status: "cleaned",
    cleanedAt: serverTimestamp(),
  });

  return true;
};

export const deleteExperience = async ({ runId, eventId } = {}) => {
  if (!eventId) return false;

  const deleteEventCascade = httpsCallable(functions, "deleteEventCascade");
  await deleteEventCascade({ eventId });

  if (runId) {
    await updateExperienceRun(runId, {
      status: "deleted",
      deletedAt: serverTimestamp(),
    });
  }

  return true;
};
